import { Box, Stack } from '@mui/material'
import LactationLogo from 'assets/LactationLogo'
import Skeleton from 'react-loading-skeleton'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

type AverageTimeCardProps = {
	title: string | number
	subTitle: string
	description: string
	isLoading: boolean
}

export const AverageTimeCard = (props: AverageTimeCardProps) => {
	return (
		<CardStandart sx={{ p: '24px', width: '100%' }}>
			<Stack
				direction={'column'}
				justifyContent={'space-between'}
				gap={'8px'}
				height={'100%'}
			>
				<Stack direction={'column'} gap={'8px'}>
					{props.isLoading ? (
						<>
							<Skeleton width='50%' height={20} />
							<Skeleton width='90%' height={20} />
						</>
					) : (
						(() => {
							const hasData = props.title !== null && props.title !== undefined

							return hasData ? (
								<>
									<Stack direction={'row'} gap={'4px'} alignItems={'center'}>
										<TypographyPrimary16Bold>
											{props?.title}
										</TypographyPrimary16Bold>
										<TypographySecondary>{props?.subTitle}</TypographySecondary>
									</Stack>
									<TypographyPrimary>{props?.description}</TypographyPrimary>
								</>
							) : (
								<>
									<TypographySecondary>Нет данных</TypographySecondary>
									<TypographyPrimary>{props?.description}</TypographyPrimary>
								</>
							)
						})()
					)}
				</Stack>

				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.blueBg,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<LactationLogo color={COLORS.blue} width={16} height={12} />
				</Box>
			</Stack>
		</CardStandart>
	)
}
